<template>
  <div
    v-if="showComponent"
    :class="$style.base"
  >
    <BaseAlert
      v-for="segment in activeSegments"
      :key="segment.key"
      :text="`${$t(`customers.segments.customer_alert`, { segment: $t(`customers.segments.segments.${segment.key.toLowerCase()}.singular_name`) })}`"
      :color="getSegmentColor(segment.key)"
      size="s"
      :primaryAction="{
        text: $t(`customers.segments.segments.${segment.key.toLowerCase()}.link`),
        routerLink: {
          name: 'customers-segments',
          params: {
            key: underscoreToDash(segment.key),
          },
        },
      }"
      v-test="'customer-segment-alert'"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { underscoreToDash } from '@/helpers/formatting';
import type { CustomerSegment } from '@/types';
import unleash from '@/unleash';

const customer = inject<any>('customer');

const activeSegments = computed<CustomerSegment[]>(() =>
  customer.value.customerSegmentations.filter((segment: any) => segment.state),
);

const showComponent = computed(
  () => unleash.isEnabled('CustomerSegments') && !!activeSegments.value.length,
);

type SegmentColor = 'primary' | 'warning' | 'success' | 'error';
const segmentColors: Record<string, SegmentColor> = {
  first_visit_follow_ups: 'primary',
  lapsing_regulars: 'warning',
};

const getSegmentColor = (key: string): SegmentColor =>
  segmentColors[key.toLowerCase()] ?? 'primary';
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing * .5;
}
</style>
